<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">打电话</a></li>
                <li><a href="#">点击通话</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>点击通话</span></div>
                <ul class="forminfo">
                    <li><label>我的号码<b>*</b></label>
                        <input name="" type="text" v-model="srcNum" class="dfinput left maringht10" />
                    </li>    
                    <li>
                        <label>选择我的号码</label>
                        <cite class="left">移动电话：<input name="check_num" @click="selectnum('mobile')" v-model="check_num" type="radio" value="mobile" />{{mobilenum}}       &nbsp;&nbsp;&nbsp;&nbsp;
                        办公电话：<input name="check_num" type="radio" @click="selectnum('office')" v-model="check_num" value="office" />{{officenum}}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        家庭电话：<input name="check_num" type="radio" @click="selectnum('home')" v-model="check_num" value="home" />{{homenum}}
                        </cite>
                    </li>
                    <li><label> 对方号码<b>*</b> </label><input name="" v-model="descNum" type="text" class="dfinput left maringht10" />
                        <div class="buttonupload  click" @click="addTxl()">从通讯录中添加</div></li>
                    
                    <li><label>通道选择<b>*</b></label>
                    <div class="cityleft">
                    <el-select style="width:300px;" v-model="sendMethod">
                        <el-option
                        v-for="item in channelList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    </div> 
                    </li>
    
                    <li><label>&nbsp;</label><input name="" type="button" class="btn" @click="senddial()" value="点击通话"/></li>
     
                </ul>
    
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>注意</b>
                </div>
    
                <ul class="infolist">
                    <li><span class="ea2020">
                通信计费模式调整 20110906起生效：</span></li>
                    <li>按分钟计费</li> 
                    <li>仅主叫一方通即计主叫方费用；主被叫均通计被叫方费用;双方均国际时计双方国际费用</li>
                    <li>当其他通话模式（如软电话）推出时另行通知调整</li>
                    <li>通道1：国内：仅主叫接通6分/分钟，主被叫均接通0.1元/分钟；国际1毛8起见国际费率</li>
                    <li>通道2：国内：仅主叫接通8分/分钟，主被叫均接通0.15元/分钟；不支持国际</li>
                    <li>通道3：国内：仅主叫接通1毛/分钟，主被叫均接通0.18元/分钟；不支持国际</li>
                    <li>通道5：国内：仅主叫接通1.2毛/分钟，主被叫均接通0.23元/分钟；国际1毛8起见国际费率</li>
                    <li>通道9：双方显示0208071开头的号码，促销价6分/分钟(原价8分/分钟)</li>
                    <li><span class="ea2020">号码输入规则:</span></li>
                    <li>1 中国大陆电话.固话和小灵通前请加区号,总号码长度不能小于10位</li>
                    <li>2 禁止拨打特殊服务号码,如110,120,119等</li>
                    <li>3 主叫号码和被叫号码可以修改\设置\选取</li>
                    <li>通道2 被叫号码限制不能为057\0580开头的固话；</li>
                    <li>通道3 双方均不能为057\0580开头的固话；限制双方同为本地固话间的通话</li>
                    <li><span class="ea2020">号码绑定</span>
                    <li>请先确认您已在网站上绑定您的号码。</li>
                    <li>第一步：根据页面提示,从本页面 "(没有号码显示点此，设置号码) " 进入绑定页面；</li>
                    <li>第二步：输入您需绑定的号码；</li>
                    <li>第三步：输入短信或收听到的验证码；</li>
                    <li>为防止骚扰,号码绑定次数每日有限制</li>
                    <li><span class="ea2020">使用方法:</span></li>
                    <li>1 按号码规则,输入(选取)主叫号码和号码</li>
                    <li>2 点击确定,稍后系统将为您接通电话</li>
                    <li>3 系统来电,您接通后请不要挂机,稍后接通被叫</li>
                    <li>4 通话结束,请挂机</li>
                    <li>拨打对方不通？</li>
                    <li><span class="ea2020">原因排查：</span></li>
                    <li>1、确认对方号码正确</li>
                    <li>2、确认对方号码正常开机或不忙（如可以用自己手机直拨下）</li>
                    <li>3、尝试在对方手机号前加上当地区号</li>
                    <li>4、输入其他号码试试,能通则可能是运营商间的互联互通问题，请向当地运营商及我们的客服反映</li>
                    <li>5、排除1－4，那可能是本系统故障，请向我们的客服反映</li>                
                </ul>
            </div>  
	    </div> 
        <!--tip1-->
        <div class="tip tip1">        
    	    <div class="tiptop"><span>第二办公室-通讯录</span><a></a></div>        
            <div class="tipinfo cen ovhi">      
                <div class="cen ovhi">
                    <label class="left lh33">选择组 &nbsp; </label>
                    <div class="cityleft">
	                    <el-select v-model="txlgroupid" @change="pageChange(1)" placeholder="请选择">
                            <el-option
                                v-for="item in txlGroupList"
                                :key="item.groupid"
                                :label="item.groupname"
                                :value="item.groupid">
                            </el-option>
                        </el-select>
                    </div>
                </div>        
                <table class="tablelist">
    	            <thead>
    	                <tr>
                            <th></th>
                            <th>姓名</th>
                            <th>号码</th>
                        </tr>
                    </thead>
                    <tbody>        
                        <tr v-for="item in txlContList">
                            <td><input name="txmobile" type="radio" @change="getCheck()" v-model="txmobile" :value="item.mphone1" /></td>
                            <td>{{item.name}}</td>
                            <td>{{item.mphone1}}</td>
                        </tr> 
                        <tr>
                            <td colspan="3">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="pageIndex"
                                    :page-size="15"
                                    layout="total, prev, pager, next"
                                    :total="totalCount">
                                </el-pagination>
                            </td>
                        </tr>
                    </tbody>
                </table>        
                <div class="cen pat20 ovhi">
                    <!-- <input name="" type="button"  class="sure"  value="确定" />&nbsp; -->
                    <input name="" type="button"  class="cancel" @click="closeTxl()"  value="取消" />
                </div>    
            </div>    
        </div>
        <!--tip1 end-->
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import { delCookie } from '@/assets/js/cookie.js'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobilenum:'',
            officenum:'',
            homenum:'',
            check_num:'',
            srcNum:'',
            descNum:'',
            sendMethod:'100',
            channelList:[
                {label:'双方显示010开头的号码，0.23元/分钟',value:'100'}
            ],
            txlGroupList:[],
            txlgroupid:'',
            txlContList:[],
            pageIndex:0,
            totalCount:0,
        }
    },
    mounted(){
        if(this.$route.query.mobile == undefined)
        {
            this.outlogin();
        }
        else
        {
            this.descNum = this.$route.query.mobile;
            this.getData();
        }
    },
    methods:{
        outlogin() {
            delCookie('2officesessionid')
            alert("请求地址有误,请重新登录！");
            this.$router.push('/');
        },
        getData(){
            let that = this
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/mohnum.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    //console.log(res.data.enterprise);
                    that.mobilenum = res.data.mohNum.mobilenum;
                    that.officenum = res.data.mohNum.officenum;
                    that.homenum = res.data.mohNum.homenum;
                    if(that.mobilenum != '')
                    {
                        that.check_num = 'mobile';
                        that.srcNum = that.mobilenum;
                    }
                    if(that.mobilenum == '' && that.officenum != '')
                    {
                        that.check_num = "office";
                        that.srcNum = that.officenum;
                    }
                    if(that.mobilenum == '' && that.officenum == '' && that.homenum != '')
                    {
                        that.check_num = 'home';
                        that.srcNum = that.homenum;
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        selectnum(val){
            if(val == 'mobile'){
                this.check_num = 'mobile';
                this.srcNum = this.mobilenum;
            }
            else if(val == 'office'){
                this.check_num = 'office';
                this.srcNum = this.officenum;
            }
            else if(val == 'home'){
                this.check_num = 'home';
                this.srcNum = this.homenum;
            }
        },
        senddial(){
            if(this.srcNum.trim() == ''){
                alert("我的号码不能为空！");
                return;
            }
            if(this.descNum.trim() == ''){
                alert("对方的号码不能为空！");
                return;
            }
            let that = this;
            let data = {'srcNum':this.srcNum,'descNum':this.descNum,'sendMethod':this.sendMethod};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/senddialphone.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("电话发起成功！")
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addTxl(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
            this.pageChange(1);
        },
        closeTxl(){
            $(".tip1").fadeOut(200);
        },
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex){
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':15, 'account':'','groupid':this.txlgroupid}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/txlcontlist.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlContList = res.data.txlContList
                    that.txlGroupList = res.data.txlGroupList
                    that.pageIndex = parseInt(pageIndex)
                    that.totalCount = res.data.page.totalCount
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getCheck(){
            var checkers = document.getElementsByName('txmobile');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    this.descNum = checkers[i].value;
                    this.closeTxl();
                }
            }
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/dial/dialsend.vue